import React, {Component} from 'react';
import { withStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import {
    Box,
    Typography
} from "@material-ui/core";
import {observer} from "mobx-react";

const style = theme => ({
    root:{
        [theme.breakpoints.up('xl')]: {
            width: '80%',
        },
        width:'100%',
        marginBottom: 70
    },
    textStyle:{
        fontFamily: 'NanumSquareRoundOTF',
        fontSize: '1.375rem',
        color: '#a3a8af',
        fontWeight: 600,
    },
    typoStyle:{
        fontSize: '1.125rem',
        fontWeight: 400,
    },
});

@observer
class SurveyParagraph extends Component {
    render() {
        const { classes, item } = this.props;

        return (
            <div className={classes.root}>
                {item.title === "" &&
                    <Typography className={classes.textStyle} style={{color:'#0d0d0d'}}>{item.title}</Typography>
                }
                <Box style={{marginTop: 50}}>
                    {item.descriptions === "" &&
                        <Typography className={clsx(classes.textStyle, classes.typoStyle)} style={{color:'#0d0d0d'}}> {item.descriptions}</Typography>
                    }
                </Box>
            </div>
        );
    }
}

export default withStyles(style)(SurveyParagraph);